import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';

export interface User {
	_id: string;
	id: string;
	username: string;
	firstName: string;
	lastName: string;
	displayName: string;
	sortName: string;
	pensum: number;
	isActive: boolean;
}

export interface UserGroup {
	_id: string;
	id: string;
	name: string;
	description: string;
	users: User[];
	deleted: boolean;
	createdAt: string;
	updatedAt: string;
}

export const useUserGroupBridge = defineStore('userGroupBridge', () => {
	const vuex = useStore();

	const userGroups = computed<UserGroup[]>(() => vuex.state.userGroup.userGroups);
	const usersMappedByID = computed(() => vuex.state.users.usersMap);

	const fetchUsers = (): Promise<void> => {
		return vuex.dispatch('users/load', true);
	};

	const fetchUserGroups = (): Promise<void> => {
		return vuex.dispatch('userGroup/load');
	};

	return {
		usersMappedByID,
		userGroups,
		fetchUsers,
		fetchUserGroups,
	};
});
